module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    ref: "tab",
    staticClass: "md-tab",
    attrs: {
      "id": _vm.tabId
    }
  }, [_vm._t("default")])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8aa44a94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8aa44a94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mdTabs/mdTab.vue
// module id = 189
// module chunks = 18 22